import {CLARITY_PROJECT_ID} from '@/shared/config';

let initialized = false;

export function initClarity(): void {
  if (typeof window === 'undefined' || initialized) {
    return;
  }

  initialized = true;

  // Official snippet: queue calls until the tag script has loaded
  window.clarity =
    window.clarity ??
    ((...args: unknown[]) => {
      window.clarity!.q = window.clarity!.q ?? [];
      window.clarity!.q.push(args);
    });

  // Loaded only after statistics consent
  window.clarity('consentv2', {
    ad_Storage: 'denied',
    analytics_Storage: 'granted',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
  document.head.appendChild(script);
}
